import React from "react";
import { Col, Row } from "react-bootstrap";
import RunningTable from "../tables/RunningTable";
import ClosedTable from "../tables/ClosedTable";

export default function Home() {
  return (
    <Row className="g-4">
      <Col xs={12}>
        <RunningTable />
      </Col>
      <Col xs={12}>
        <ClosedTable />
      </Col>
    </Row>
  );
}

